export default __webpack_public_path__ + "static/media/misc-books4-2048w.d2a37c9d.avif";